import React from 'react';

import './style.scss';

const ProgressIndicator = ({ progress }) => {
  return (
    <div className="ProgressIndicator">
      <div className="ProgressIndicator__progress" style={{ width: `${progress * 100}%` }} />
    </div>
  );
};

export default ProgressIndicator;
